<template>
    <div>
        <div class="h-screen flex items-center" v-if="loadingStatus">
            <div class="m-auto">
                <Ripple :isLoading="loadingStatus" />
            </div>
        </div>


        <div v-else class="bg-white lg:mx-60 text-xs lg:text-sm">

            <div v-if="activeTab == 0">
                <div class="flex justify-between items-center mb-14 mx-4 md:px-4 pt-4">
                    <img src="../../assets/images/sycamore_logo.svg" class="w-28 md:w-56">

                    <div>
                        <span class="text-black">
                            Offer letter {{ loan ? loan.contract_status : '' }}
                        </span>
                        <p v-if="currency.slug == 'nigerian-naira'">RC : 1505897</p>
                        <p v-if="currency.slug == 'british-pound'">RC : 16181852</p>
                    </div>
                </div>

                <div class="md:w-10/12 m-auto">
                    <div class="mt-12 px-4 lg:px-12 space-y-12">
                        <div>
                            <p>
                                {{ loan ? String(loan.loan_id).toUpperCase() : '' }}
                            </p>
                            <p>
                                {{ loan.Customer ? loan.Customer.address : '' }}
                            </p>
                            <p class="font-bold">
                                Hello {{ loan.Customer ? loan.Customer.name : '' }},
                            </p>
                        </div>

                        <div>
                            <h3 class="pb-4 text-sm font-semibold">OFFER LETTER</h3>
                            <ul class="text-gray-500">
                                <li class="flex justify-between pb-2 lg:px-6 mb-2 border-b-2">
                                    <span class="text-black">Borrower Name</span>
                                    <span>{{ loan.Customer ? loan.Customer.name : '' }}</span>
                                </li>

                                <li class="flex justify-between pb-2 lg:px-6 mb-2 border-b-2">
                                    <span class="text-black">Principal</span>
                                    <span>{{ currency.symbol }}{{ loan.amount_requested ? Number(loan.amount_requested ||
                                        0).toLocaleString('en-NG', { minimumFractionDigits: 2, maximumFractionDigits: 2})
                                        : 'None'}}</span>
                                </li>

                                <li class="flex justify-between pb-2 lg:px-6 mb-2 border-b-2">
                                    <span class="text-black">Interest Rate</span>
                                    <span>{{ loan.rate }}% per {{ loan.duration_type }}</span>
                                </li>

                                <li class="flex justify-between pb-2 lg:px-6 mb-2 border-b-2">
                                    <span class="text-black">Total Interest</span>
                                    <span>{{ currency.symbol }}{{ Number(total_interest || 0).toLocaleString('en-NG',
                                        {minimumFractionDigits: 2, maximumFractionDigits: 2}) }}</span>
                                </li>

                                <li class="flex justify-between pb-2 lg:px-6 mb-2 border-b-2">
                                    <span class="text-black">Amount disbursed</span>
                                    <span>{{ currency.symbol }}{{ Number(loan.amount_disbursed).toLocaleString('en-NG',
                                        {minimumFractionDigits: 2, maximumFractionDigits: 2}) }}</span>
                                </li>

                                <li class="flex justify-between pb-2 lg:px-6 mb-2 border-b-2">
                                    <span class="text-black">Total repayment</span>
                                    <span>{{ currency.symbol }}{{ Number((total_principal + total_interest) ||
                                        0).toLocaleString('en-NG', {minimumFractionDigits: 2, maximumFractionDigits: 2})
                                        }}</span>
                                </li>

                                <li class="flex justify-between pb-2 lg:px-6 mb-2 border-b-2">
                                    <span v-if="loan.duration_type == 'day'" class="text-black">Daily
                                        Installments</span>
                                    <span v-if="loan.duration_type == 'week'" class="text-black">Weekly
                                        Installments</span>
                                    <span v-if="loan.duration_type == 'month'" class="text-black">Monthly
                                        Installments</span>
                                    <span>{{ currency.symbol }}{{ first_schedule ? Number((first_schedule.interestTobePaid
                                        + first_schedule.principalTobePaid) || 0).toLocaleString('en-NG',
                                        {minimumFractionDigits: 2, maximumFractionDigits: 2}) : 'None' }}</span>
                                </li>

                                <li class="flex justify-between pb-2 lg:px-6 mb-2 border-b-2">
                                    <span class="text-black">Duration</span>
                                    <span>{{ `${loan.duration} ${loan.duration_type}s` }}</span>
                                </li>

                                <li class="flex justify-between pb-2 lg:px-6 mb-2 border-b-2">
                                    <span class="text-black">Maturity Date</span>
                                    <span>{{ maturity_date == '' ? 'N/A' : moment(maturity_date).format('MMM Do, YYYY')
                                        }}</span>
                                </li>

                                <li class="flex justify-between pb-2 lg:px-6 mb-2 border-b-2">
                                    <span class="text-black">Disbursement Date</span>
                                    <span>{{ loan.disbursement_date == null ? 'N/A' :
                                        moment(loan.disbursement_date).format('MMM Do, YYYY') }}</span>
                                </li>

                                <li class="flex justify-between pb-2 lg:px-6 mb-2 border-b-2">
                                    <span class="text-black">Date created</span>
                                    <span>{{ moment(loan.createdAt).format('MMM Do, YYYY') }} {{ new
                                        Date(loan.createdAt).toLocaleTimeString(
                                        'en-GB', { hour: "numeric", minute: "numeric"}) }}</span>
                                </li>

                                <li class="flex justify-between pb-2 lg:px-6 mb-2 border-b-2">
                                    <span class="text-black">Date updated</span>
                                    <span>{{ moment(loan.updatedAt).format('MMM Do, YYYY') }} {{ new
                                        Date(loan.updatedAt).toLocaleTimeString(
                                        'en-GB', { hour: "numeric", minute: "numeric"}) }}</span>
                                </li>

                                <li class="flex justify-between pb-2 lg:px-6 mb-2 border-b-2">
                                    <span class="text-black">Date decided on</span>
                                    <span v-if="loan.contract_decided_on == null">Not decided</span>
                                    <span v-else>{{ moment(loan.contract_decided_on).format('MMM Do, YYYY') }} {{ new
                                        Date(loan.contract_decided_on).toLocaleTimeString(
                                        'en-GB', { hour: "numeric", minute: "numeric"}) }}</span>
                                </li>

                                <li class="flex justify-between pb-2 lg:px-6 mb-2 border-b-2">
                                    <span class="text-black">First Repayment Date</span>
                                    <span>{{ first_schedule ? moment(first_schedule.dueDate).format('MMM Do, YYYY') :
                                        'None' }}</span>
                                </li>
                            </ul>
                        </div>

                        <div v-if="loan.DisbursementDeductions?.length > 0">
                            <h3 class="pb-4 text-sm font-semibold">LOAN DEDUCTIONS</h3>

                            <div class="overflow-x-auto pb-2">
                                <table>
                                    <tr>
                                        <th>Description</th>
                                        <th>Amount</th>
                                    </tr>

                                    <tr v-for="(deduction, index) in loan.DisbursementDeductions" :key="index">
                                        <td>{{ deduction.description }}</td>
                                        <td>-{{ currency.symbol }}{{ Number(deduction.amount || 0).toLocaleString('en-NG',
                                            {minimumFractionDigits: 2, maximumFractionDigits: 2}) }}</td>
                                    </tr>
                                </table>
                            </div>
                        </div>

                        <div v-if="loan.duration_type == 'month'">
                            <h3 class="pb-4 text-sm font-semibold">REPAYMENT SCHEDULE</h3>

                            <div class="overflow-x-auto pb-2">
                                <table>
                                    <tr class="">
                                        <th>Due date</th>
                                        <th>Opening balance</th>
                                        <th>Principal</th>
                                        <th>Interest</th>
                                        <th>Repayment</th>
                                        <th>Close balance</th>
                                        <th>Paid</th>
                                    </tr>

                                    <tr v-for="(schedule, index) in repayment_schedules" :key="index">
                                        <td>{{ schedule.dueDate ? moment(schedule.dueDate).format('MMM Do, YYYY') :
                                            'None'}}</td>
                                        <td>
                                            <div>{{ currency.symbol }}{{ schedule.openingBalance ?
                                                Number(schedule.openingBalance || 0).toLocaleString('en-NG',
                                                {minimumFractionDigits: 2, maximumFractionDigits: 2}): 'None' }}</div>
                                            <!-- <div v-if="currency.slug == 'british-pound'" class="text-gray-600">
                                                <div class="text-xs text-gray-400 font-medium">converted to</div>
                                                {{ naira_object?.symbol }}{{ Number((schedule.openingBalance || 0) * to_naira_rate_with_buffer).toLocaleString('en-NG',
                                                {minimumFractionDigits: 2, maximumFractionDigits: 2}) }}
                                            </div> -->
                                        </td>

                                        <td>
                                            <div>{{ currency.symbol }}{{ schedule.principalTobePaid ?
                                                Number(schedule.principalTobePaid || 0).toLocaleString('en-NG',
                                                {minimumFractionDigits: 2, maximumFractionDigits: 2}) : 'None' }}</div>
                                            <!-- <div v-if="currency.slug == 'british-pound'" class="text-gray-600">
                                                <div class="text-xs text-gray-400 font-medium">converted to</div>
                                                {{ naira_object?.symbol }}{{ Number((schedule.principalTobePaid || 0) * to_naira_rate_with_buffer).toLocaleString('en-NG',
                                                {minimumFractionDigits: 2, maximumFractionDigits: 2}) }}
                                            </div> -->
                                        </td>
                                        <td>
                                            <div>{{ currency.symbol }}{{ schedule.interestTobePaid ?
                                                Number(schedule.interestTobePaid || 0).toLocaleString('en-NG',
                                                {minimumFractionDigits: 2, maximumFractionDigits: 2}) : 'None' }}</div>
                                            <!-- <div v-if="currency.slug == 'british-pound'" class="text-gray-600">
                                                <div class="text-xs text-gray-400 font-medium">converted to</div>
                                                {{ naira_object?.symbol }}{{ Number((schedule.interestTobePaid || 0) * to_naira_rate_with_buffer).toLocaleString('en-NG',
                                                {minimumFractionDigits: 2, maximumFractionDigits: 2}) }}
                                            </div> -->
                                        </td>

                                        <td>
                                            <div>{{ currency.symbol }}{{ Number((schedule.principalTobePaid +
                                                schedule.interestTobePaid) || 0).toLocaleString('en-NG',
                                                {minimumFractionDigits: 2, maximumFractionDigits: 2}) }}</div>
                                            <!-- <div v-if="currency.slug == 'british-pound'" class="text-gray-600">
                                                <div class="text-xs text-gray-400 font-medium">converted to</div>
                                                {{ naira_object?.symbol }}{{ Number(((schedule.principalTobePaid || 0) + (schedule.interestTobePaid || 0)) * to_naira_rate_with_buffer).toLocaleString('en-NG',
                                                {minimumFractionDigits: 2, maximumFractionDigits: 2}) }}
                                            </div> -->
                                        </td>
                                        <td>
                                            <div>{{ currency.symbol }}{{ Number(schedule.closingBalance ||
                                                0).toLocaleString('en-NG', {minimumFractionDigits: 2, maximumFractionDigits:
                                                2}) }}</div>
                                            <!-- <div v-if="currency.slug == 'british-pound'" class="text-gray-600">
                                                <div class="text-xs text-gray-400 font-medium">converted to</div>
                                                {{ naira_object?.symbol }}{{ Number((schedule.closingBalance || 0) * to_naira_rate_with_buffer).toLocaleString('en-NG',
                                                {minimumFractionDigits: 2, maximumFractionDigits: 2}) }}
                                            </div> -->
                                        </td>
                                        <td>
                                            <div>{{ currency.symbol }}{{ Number(schedule.amountPaid ||
                                                0).toLocaleString('en-NG', {minimumFractionDigits: 2, maximumFractionDigits:
                                                2}) }}</div>
                                            <!-- <div v-if="currency.slug == 'british-pound'" class="text-gray-600">
                                                <div class="text-xs text-gray-400 font-medium">converted to</div>
                                                {{ naira_object?.symbol }}{{ Number((schedule.amountPaid || 0) * to_naira_rate_with_buffer).toLocaleString('en-NG',
                                                {minimumFractionDigits: 2, maximumFractionDigits: 2}) }}
                                            </div> -->
                                        </td>
                                    </tr>
                                </table>
                            </div>
                        </div>

                        <div>
                            <h3 class="pb-4 text-sm font-semibold">GENERAL TERMS AND CONDITIONS</h3>
                            <p class="pb-4">
                                This Loan Offer Letter (the "Agreement") sets out the terms and conditions under which Sycamore Integrated Solutions Limited ("Sycamore" or "the Lender") agrees to make available a financial facility ("the Facility") to the Borrower, subject to compliance with applicable laws and ethical lending standards.
                            </p>

                            <ol class="space-y-10 pl-4 text-justify numbered" style="line-height: 1.5rem;">
                                <li>
                                    <h3 class="font-semibold pb-2">Advance and Repayment</h3>
                                    <ol class="space-y-3">
                                        <li>
                                            Sycamore agrees to advance the Facility and the Borrower agrees to take the same under the terms contained herein and in the Facility Application Form.
                                        </li>

                                        <li>
                                            The Facility shall attract interest and other applicable charges as provided in this Agreement.
                                        </li>

                                        <li>
                                            Repayment shall be made on the due date(s) stated in the repayment schedule.
                                        </li>

                                        <li>
                                            Interest shall be charged on a flat monthly basis, calculated on the total principal amount for the duration of the Facility.
                                        </li>

                                        <li>
                                            Sycamore reserves the right to initiate repayment up to three (3) days earlier than the scheduled date to prevent technical default.
                                        </li>

                                        <li>
                                            Where the Borrower fails to meet any repayment obligation when due, Sycamore reserves the right to apply default interest at a rate equivalent to three-quarters (¾) of the applicable contractual interest rate, in addition to the normal interest accruing on the overdue amount. Sycamore shall not ordinarily apply such default interest except in cases where the Borrower is found to be acting in bad faith, being deliberately evasive, mischievous, or uncooperative, or where the delay or default is considered severe or persistent. In such circumstances, Sycamore may also apply late payment charges and administrative recovery fees in line with the prevailing rates disclosed at the time of disbursement. Any default interest or related charges shall continue to accrue until all outstanding sums are fully repaid, and shall be deemed as damages to compensate Sycamore for administrative costs, funding exposure, and loss of use of funds, without prejudice to any other rights or remedies available to Sycamore under law or this agreement.
                                        </li>

                                        <li>
                                            Repayment shall continue until all sums due (principal, interest, fees, penalties, and expenses) are fully settled.
                                        </li>
                                    </ol>
                                </li>

                                <li v-if="currency.slug == 'british-pound'">
                                    <h3 class="font-semibold pb-2">Condition Precedent:</h3>
                                    <p class="pb-2">
                                        Before the disbursement of the Loan Amount, the Borrower shall fulfil the
                                        following conditions precedent to the
                                        satisfaction of Sycamore:
                                    </p>
                                    <ol class="space-y-3">
                                        <li>
                                            Open and maintain an active  Bank Account with any of the exclusive designated agents of Sycamore, in accordance with their terms and conditions.
                                        </li>

                                        <li>
                                            Cause the payroll department of Borrower's employer to direct deposit Borrower's entire monthly salary, net of all statutory deductions, into that  account. This requirement shall remain in effect throughout the entire term of this Loan Agreement.
                                        </li>

                                        <li>
                                            The Borrower shall provide Sycamore with written confirmation from the bank or agency verifying that:
                                            <ol class="space-y-3 mt-2">
                                                <li>The Borrower has opened and maintained an active account.
                                                </li>
                                                <li>The Borrower's salary is being directly deposited into that account.
                                                </li>
                                                <li>A valid direct debit mandate is in place for automatic loan repayments.
                                                </li>
                                            </ol>
                                        </li>

                                        <li>
                                            Submission of any additional documents, certifications, or evidence as
                                            reasonably required by Sycamore to
                                            verify the Borrower's financial standing, creditworthiness, or any other
                                            relevant information related to the
                                            Loan Amount.
                                        </li>

                                        <li>
                                            Sycamore reserves the right to review and verify the conditions precedent
                                            before proceeding with the
                                            disbursement. If any condition precedent is not satisfied to the reasonable
                                            satisfaction of Sycamore,
                                            Sycamore may, at its discretion, decline to disburse the Loan Amount and
                                            terminate this Agreement without
                                            any liability to the Borrower.
                                        </li>

                                        <li>
                                            The disbursement of the Loan Amount shall only occur upon the satisfaction
                                            of all applicable conditions
                                            precedent to Sycamore's satisfaction. Sycamore shall notify the Borrower in
                                            writing of its decision to
                                            disburse the Loan Amount.
                                        </li>

                                        <li>
                                            The Borrower acknowledges and agrees that the satisfaction of the
                                            condition’s precedent does not relieve the
                                            Borrower from its obligations under this Agreement and that the disbursement
                                            of the Loan Amount does not
                                            constitute a waiver of any rights or remedies available to Sycamore in the
                                            event of default by the Borrower.
                                        </li>

                                        <li>Sycamore may, at any time, request additional conditions precedent to
                                            disbursement or modify the existing
                                            conditions precedent upon providing written notice to the Borrower.</li>

                                        <li>
                                            If the Borrower fails to comply with any of the foregoing conditions
                                            precedent by the closing date, Sycamore
                                            shall have the right, at its sole discretion, to:
                                            <ol class="space-y-1 mt-2">
                                                <li>Decline to make the Loan.</li>
                                                <li>Terminate this Loan Agreement immediately if the Loan has already
                                                    been funded.</li>
                                                <li>Seek any other remedies available at law or equity.</li>
                                            </ol>
                                        </li>

                                        <li>This condition precedent is for the sole benefit of Sycamore and does not create any rights or obligations for the collections agency, except as outlined in its agreement with Sycamore.</li>
                                    </ol>
                                </li>

                                <li>
                                    <h3 class="font-semibold pb-2">Interest and Charges</h3>
                                    <ol class="space-y-3">
                                        <li>
                                            The Facility shall attract flat monthly interest between 5% and 18%, depending on tenor, size, and risk classification.
                                        </li>

                                        <li>
                                            Interest shall accrue daily but be charged and payable monthly. Interest and principal sums are paid on a flat monthly basis. The interest and principal are calculated above and shall be in line with the schedule and table above.
                                        </li>

                                        <li>
                                            In the event of default, default interest shall accrue on any unpaid amount from the due date until payment in full. Such default interest shall be charged in addition to normal interest.
                                        </li>

                                        <li>
                                            Sycamore reserves the right to apply a risk-based interest fee (1%) per disbursement, deducted upfront to provide a credit risk cover.
                                        </li>

                                        <li>
                                            All accrued interest and penalties shall continue to apply before and after any judgment obtained in favour of Sycamore.
                                        </li>

                                        <li>
                                            Interest and penalties represent liquidated damages and not a penalty in law, to compensate Sycamore for administrative, opportunity, and risk costs.
                                        </li>
                                    </ol>
                                </li>

                                <li v-if="currency.slug == 'british-pound'">
                                    <h3 class="font-semibold pb-2">Direct Debit Mandate</h3>
                                    <ol class="space-y-3">
                                        <li>
                                            The Borrower shall, before  the disbursement of the Loan Amount, irrevocably authorise Sycamore collections agency to initiate automatic monthly withdrawals from the their account or transfer the amount sufficient to cover the Borrower's monthly loan repayment obligation under this Loan Agreement to the authorised account in clause 4.3. This authorisation shall remain in effect until the Loan is paid in full.
                                        </li>

                                        <li>
                                            In accordance with the provision above, Sycamore, through its authorised account and  collection agency and any other prescribed/stipulated means or collection agency  shall have the right to directly debit the Borrower's account or any other account maintained by Borrower in any bank in the United Kingdom for all interest charges on the Loan Amount on the first day of each and every month commencing on 
                                            <strong>(Month)
                                                (Day) (Year)</strong>, and any fees, charges or other sums (including without limitation, principal) due to Sycamore as and when the same shall be due and payable.

                                        </li>

                                        <!-- <li>All repayments shall be made to the following bank account as the authorized
                                            account: <br>
                                            <p class="pt-4"><span class="font-bold">International and Local BicSwift
                                                    Payment</span> : Use this to make
                                                international and local wire payments for your repayments transactions
                                            </p>
                                            ACCOUNT NAME: Sycamore Integrated Solutions Limited <br>
                                            ACCOUNT NUMBER: GB90LEAT04069100023539 <br>
                                            SWIFT CODE: LEATGB22XXX <br>
                                            BANK NAME: Leatherback Ltd <br>


                                            <p class="font-bold pt-4">Local SortCode Payment</p>

                                            Use this to make local wire payments for your transactions <br>
                                            ACCOUNT NAME: Sycamore Integrated Solutions Limited <br>
                                            ACCOUNT NUMBER: 00023539 <br>
                                            SORT CODE: 040691 <br>
                                            BANK NAME: Leatherback Ltd <br>
                                        </li> -->
                                        <li>
                                            Unless otherwise agreed upon in writing, Payments must be made in GBP
                                            through direct debit from the
                                            Borrower’s account to the account above or any other alternative payment
                                            platform requested by Sycamore
                                            Integrated Solutions Limited.
                                        </li>
                                        <li>
                                            There shall be a one percent fee (1%) insurance fee charged to insure and
                                            process the loan which shall be
                                            deducted from the total amount paid to the borrower.
                                        </li>
                                    </ol>
                                </li>

                                <li>
                                    <h3 class="font-semibold pb-2">Early Liquidation</h3>
                                    <ol class="space-y-3">
                                        <li>
                                            If the Borrower repays the Facility before the agreed maturity date, early liquidation is welcomed on the agreed rates.
                                        </li>
                                        <li>
                                            Where liquidation occurs within the first month, the Borrower shall pay the full amount in addition to any applicable fees, if any.
                                        </li>
                                    </ol>
                                </li>


                                <li>
                                    <h3 class="font-semibold pb-2">Administrative Charges</h3>
                                    <p class="pb-2">In the event of a missed repayment or breach, Sycamore can choose impose:</p>
                                    <ol class="space-y-3">
                                        <li>Late payment fees;</li>
                                        <li>Collection and administrative charges;</li>
                                        <li>Third-party recovery costs, including legal and enforcement expenses.</li>
                                    </ol>
                                </li>

                                <li>
                                    <h3 class="font-semibold pb-2">Representations and Warranties</h3>
                                    <p class="pb-2">
                                        The Borrower hereby warrants, represents, and undertakes to Sycamore Integrated Solutions Limited ("Sycamore") that all information, documents, declarations, and representations made or delivered to Sycamore in connection with this Facility are true, complete, and accurate in all material respects, and that no material fact has been withheld, misrepresented, or falsified in a way that could influence Sycamore's decision to approve, disburse, or maintain the Facility. The Borrower further affirms that the Facility shall be used solely for lawful, legitimate, and ethical purposes, and shall not be diverted toward any illegal, fraudulent, or unapproved activity.
                                    </p>
                                    <p class="pb-2">
                                        The Borrower also represents that he/she possesses the full legal capacity, authority, and competence to enter into and perform the obligations under this Agreement, and that doing so does not and will not conflict with any other contractual, financial, or legal obligation binding upon the Borrower.
                                    </p>
                                    <p class="pb-2">
                                        The Borrower acknowledges that any misrepresentation, falsification, or concealment of information shall constitute a material breach of this Agreement, entitling Sycamore to demand immediate repayment, enforce any collateral or security held, and report such conduct to credit bureaus or relevant authorities as allowed by law.
                                    </p>
                                    <p class="pb-4">
                                        He/she will use the Sycamore Facility for the purpose(s) they told Sycamore of in their application for the Sycamore Facility.
                                    </p>
                                    
                                    <ol class="space-y-3">
                                        <li>
                                            <h4 class="font-semibold pb-2">Data Protection and Privacy Warranty</h4>
                                            <p class="pb-2">
                                                In compliance with the Nigeria Data Protection Act 2023 (NDPA) and the FCCPC Consumer Credit Guidelines 2025, the Borrower expressly consents to the lawful collection, processing, and storage of personal, transactional, and financial data by Sycamore for the legitimate purposes of credit assessment, loan management, and regulatory reporting.
                                            </p>
                                            <p class="pb-2">
                                                Sycamore shall ensure that all such data is processed lawfully, fairly, and transparently, stored securely, and shall not be shared with third parties except:
                                            </p>
                                            <ul class="pl-4 space-y-1 pb-2">
                                                <li>Where required or permitted by law or regulation;</li>
                                                <li>For credit referencing, debt recovery, fraud prevention, or risk assessment; or</li>
                                                <li>With authorized partners or service providers bound by confidentiality and data protection obligations.</li>
                                            </ul>
                                            <p class="pb-2">
                                                The Borrower acknowledges that Sycamore may lawfully disclose performance or default information to licensed credit bureaus, regulators, or enforcement agencies, in line with applicable laws and ethical lending standards.
                                            </p>
                                            <p>
                                                The Borrower undertakes to promptly update Sycamore of any change in information (including residential, employment, or financial status) that may affect the performance of this Facility.
                                            </p>
                                        </li>

                                        <li>
                                            <h4 class="font-semibold pb-2">Borrower's Acknowledgment of Consumer Rights</h4>
                                            <p class="pb-2">
                                                The Borrower acknowledges that Sycamore operates under the Federal Competition and Consumer Protection Act (FCCPC) 2018, the Consumer Credit Guidelines 2025, and applicable fair lending regulations, and therefore:
                                            </p>
                                            <ul class="pl-4 space-y-2">
                                                <li>The Borrower is entitled to clear, transparent, and understandable disclosure of all material loan terms, fees, and charges prior to acceptance.</li>
                                                <li>The Borrower has the right to fair treatment, and Sycamore shall ensure that all interactions are respectful, and consistent with applicable consumer protection standards.</li>
                                                <li>The Borrower retains the right to lodge a complaint or seek redress through Sycamore's official dispute resolution channels, and if unresolved within 28 days, the borrower shall send a second notification and if unresolved after 14 days, he/she can escalate to any authority or ADR platforms.</li>
                                                <li>The Borrower acknowledges that Sycamore, while exercising its contractual and legal rights, may take necessary enforcement steps only in accordance with the law and after due notice where applicable.</li>
                                            </ul>
                                        </li>
                                    </ol>
                                </li>

                                <li>
                                    <h3 class="font-semibold pb-2">Events of Default</h3>
                                    <p class="pb-2">A default occurs if:</p>
                                    <ol class="space-y-3">
                                        <li>
                                            Any payment is not made when due;
                                        </li>

                                        <li>
                                            The Borrower breaches any covenant herein;
                                        </li>

                                        <li>
                                            Any representation or warranty proves false;
                                        </li>

                                        <li>
                                            Where a situation arises which in the opinion of Sycamore makes it inappropriate to continue to extend the facility to the Borrower. Where the Borrower defaults in the performance or observance of any other term, condition or covenant herein and such breach or default shall continue unremedied after ten days' notice shall have been given to the Borrower.
                                        </li>

                                        <li>
                                            The Borrower becomes insolvent, bankrupt, or subject to a winding-up petition. Upon default, Sycamore may demand immediate repayment of all sums due and enforce security or collateral.
                                        </li>
                                    </ol>
                                </li>

                                <li>
                                    <h3 class="font-semibold pb-2">Data Protection and Confidentiality</h3>
                                    <ol class="space-y-3">
                                        <li>
                                            Sycamore shall handle all personal data of the Borrower in compliance with the Nigeria Data Protection Act, 2023 (NDPA).
                                        </li>
                                        <li>
                                            The Borrower consents to Sycamore sharing relevant data with:
                                            <ul class="pl-4 space-y-1 mt-2">
                                                <li>Licensed Credit Bureaus;</li>
                                                <li>Debt Recovery Agents;</li>
                                                <li>Financial Service Partners; and</li>
                                                <li>Regulatory Authorities.</li>
                                            </ul>
                                        </li>
                                        <li>
                                            The Borrower has the right to request access, rectification, or deletion of personal data, subject to lawful limitations.
                                        </li>
                                    </ol>
                                </li>

                                <li>
                                    <h3 class="font-semibold pb-2">Complaint Resolution</h3>
                                    <ol class="space-y-3">
                                        <li>
                                            The Borrower shall first direct any complaint to Sycamore’s Customer Experience Desk, as prescribed in the warranties above at paragraph 5.
                                        </li>
                                        <li>
                                            If unresolved, the matter shall be referred to the FCCPC-approved dispute resolution mechanism before recourse to court. Provided always that nothing in this clause shall be construed as precluding the Company from initiating legal proceedings in a court of competent jurisdiction for the recovery of outstanding debts, the enforcement of any security or collateral, the pursuit of injunctive relief, or in any matter involving suspected fraud, without prior recourse to the dispute resolution mechanisms described herein.
                                        </li>
                                    </ol>
                                </li>

                                <li>
                                    <h3 class="font-semibold pb-2">Costs and Indemnity</h3>
                                    <ol class="space-y-3">
                                        <li>
                                            The Borrower agrees to indemnify and hold the Company harmless from any and all losses, damages, liabilities, and expenses (including, without limitation to, legal fees, debt recovery costs, valuation fees, receivership costs, auctioneer fees, and other professional fees) incurred in the enforcement of this Agreement. This indemnity shall survive the termination, repayment, or settlement of the Facility and shall remain fully enforceable.
                                        </li>
                                    </ol>
                                </li>



                                <li v-if="currency.slug == 'british-pound'">
                                    <h3 class="font-semibold pb-2">Prepayment</h3>
                                    <ol class="space-y-3">
                                        <li>
                                            The Borrower may prepay the Loan, in whole or in part, on any payment date together with interest accrued thereon, through the authorized account  upon giving prior written notice of not less than 30 (thirty) days to Sycamore (such notice once given is irrevocable). And with evidence of payments to designated email for notices.
                                        </li>

                                        <li>
                                            The Borrower shall exclusively pay to the authorised account and all other additional amounts to compensate Sycamore for any loss and expense incurred by Sycamore as a result of such prepayment.
                                        </li>

                                        <li>
                                            Any amount prepaid shall be cancelled and shall not be re-borrowed.
                                        </li>
                                    </ol>
                                </li>

                                <li>
                                    <h3 class="font-semibold pb-2">Set-Off and Right of Appropriation</h3>
                                    <p>
                                        Sycamore may, without notice, set off any amount due from the Borrower against funds standing to the Borrower's credit in any account maintained with Sycamore or any of its partners.
                                    </p>
                                </li>

                                <li>
                                    <h3 class="font-semibold pb-2">Variation and Assignment</h3>
                                    <ol class="space-y-3">
                                        <li>
                                            Sycamore reserves the right to review or vary the terms of this Agreement upon written notice.
                                        </li>
                                        <li>
                                            Sycamore may assign or transfer its rights or obligations to third parties, including securitization or loan sale, without prior consent from the Borrower.
                                        </li>
                                    </ol>
                                </li>

                                <li>
                                    <h3 class="font-semibold pb-2">Collateral and Enforcement</h3>
                                    <ol class="space-y-3">
                                        <li>
                                            Sycamore reserves the right to realize any collateral pledged once default occurs.
                                        </li>
                                        <li>
                                            Issuance of a dud cheque or falsified document constitutes fraud and shall attract criminal liability under the relevant laws. The Borrower hereby grants to the Company a legal/equitable mortgage over the collateral as security for the facility. Upon an event of default, the Company shall have the immediate and irrevocable right to exercise its power of sale over the collateral without the need for a court order. The Borrower expressly waives any right to seek an injunction or any other equitable relief to restrain the Company from exercising its power of sale.
                                        </li>
                                    </ol>
                                </li>

                                <li v-if="currency.slug == 'nigerian-naira'">
                                    <h3 class="font-semibold pb-2">Fraud and Misrepresentation</h3>
                                    <ol class="space-y-3">
                                        <li>
                                            The Borrower warrants that all information, representations, and documents (including collateral titles) provided to Sycamore for this Facility are true, accurate, and complete. The Borrower is hereby warned that any act of fraud, including the provision of false information or the deliberate obstruction of recovery through collusion with third parties, shall result in: Immediate termination of the Facility and acceleration of the total Outstanding Sum, and the formal reporting of the Borrower to relevant Law Enforcement Agencies (including the Economic and Financial Crimes Commission or the Nigerian Police Force) for criminal investigation.
                                        </li>
                                    </ol>
                                </li>

                                <li v-if="currency.slug == 'british-pound'">
                                    <h3 class="font-semibold pb-2">Data</h3>
                                    <p>
                                        The Borrower agrees and consents Sycamore and/or other persons authorized by
                                        Sycamore to examine, disclose,
                                        exchange, use, compile and access any information concerning the Borrower,
                                        whether general information, personal
                                        data, information and financial status of the Borrower (whether directly or
                                        through a third party), information
                                        relating to credit facilities, services or financial transactions with Sycamore,
                                        electronic data and any other
                                        information related to the Borrower, in any form whatsoever (hereinafter
                                        collectively referred to as the
                                        “Data”), including to analyse and assess the Borrower’s Data and the data in
                                        Sycamore’s data base, for the
                                        purposes of loan collection, consideration, granting, reviewing or extension of
                                        credit facilities
                                        agreement/credit or debt restructuring; or for the purposes of assignment of
                                        rights and duties or compilation,
                                        utilisation, disclosure, record keeping, delivery and transfer of the Data; or
                                        for the purpose of receiving
                                        news, information or proposal of any service; or for any other purpose,
                                        necessity or objective as Sycamore deems
                                        appropriate to send the information to or receive from any person, juristic
                                        person, state enterprise, private
                                        entity that Sycamore deems appropriate; or any tax authority of any jurisdiction
                                        to which the Borrower is liable
                                        to pay taxes and stamp duties; or obligation by contract or agreement with any
                                        supervisory authority or
                                        authority; or any other person required by the laws, whether in or outside of
                                        United Kingdom and/or Federal
                                        Republic of Nigeria.
                                    </p>
                                </li>

                                <li>
                                    <h3 class="font-semibold pb-2">Governing Law</h3>
                                    <p v-if="currency.slug == 'nigerian-naira'">
                                        This Agreement shall be governed by the laws of the Federal Republic of Nigeria, and disputes shall be subject to the exclusive jurisdiction of the Nigerian Courts.
                                    </p>

                                    <p v-if="currency.slug == 'british-pound'">
                                        This Agreement shall be governed by and construed in accordance with the
                                        substantive laws of both the Federal
                                        Republic of Nigeria and the United Kingdom, without regard to conflict of laws
                                        principles.
                                    </p>
                                </li>

                                <li v-if="currency.slug == 'british-pound'">
                                    <h3 class="font-semibold pb-2">Dispute Resolution</h3>
                                    <ol class="space-y-3">
                                        <li>If any dispute arises between the Parties relating to or arising out of this
                                            Agreement (a “Dispute”), the
                                            Parties undertake to settle the Dispute amicably among themselves.</li>

                                        <li>The Parties shall do all within their efforts to settle any dispute arising
                                            between them amicably, utilising
                                            discussions, within 15 (fifteen) days of written notification of any dispute
                                            by the affected Party.</li>

                                        <li>Any dispute, controversy, or claim arising out of or in connection with this
                                            Agreement, or the breach,
                                            termination, or invalidity thereof, excluding any dispute solely concerning
                                            the enforcement of repayment of
                                            Loan in the United Kingdom under this Agreement, shall be finally settled by
                                            arbitration in accordance with
                                            the Arbitration and Mediation Act of Nigeria 2023 or the Arbitration Act
                                            1996 of England and Wales, as
                                            mutually agreed upon by the parties.
                                            <ol class="space-y-3 mt-1">
                                                <li>The mediation seat, or legal place, shall be London, United Kingdom.
                                                    The language to be used in the
                                                    mediation proceedings shall be English.</li>
                                                <li>The arbitral award shall be final and binding upon the parties and
                                                    may be enforced in any court of
                                                    competent jurisdiction in Nigeria or the United Kingdom.</li>
                                            </ol>
                                        </li>

                                        <li>
                                            Nothing in this clause shall limit or be construed to limit the right of either Party to take proceedings against the other Party in any court of competent jurisdiction to obtain security for its claim or injunctive relief against the other Party. Sycamore has the right to report to the registered credit bureau of the UK where the borrower defaults or acts in bad faith that hinders the repayments of his loan.
                                        </li>

                                        <li>
                                            When a dispute arises and is under mediation, except for the matter under
                                            Dispute, the Parties shall
                                            continue to exercise their respective rights and fulfil their remaining
                                            obligations under this Agreement.
                                        </li>

                                        <li>
                                            Notice of mediation and service of any legal proceedings permitted by this
                                            clause or at law may be validly
                                            effected by or under cover of any Notice sent in conformity with this
                                            Agreement, and neither Party shall
                                            contest service effected by these means.
                                        </li>

                                        <li>
                                            Notwithstanding the foregoing, any dispute solely concerning the enforcement
                                            of repayment of the London
                                            under this Agreement shall be subject to the exclusive jurisdiction of the
                                            courts of the United Kingdom."
                                        </li>
                                    </ol>
                                </li>

                                <li>
                                    <h3 class="font-semibold pb-2">Acceptance and Consent</h3>
                                    <p class="pb-2">By signing or digitally accepting this Offer Letter, the Borrower confirms that they have:</p>
                                    <ul class="pl-4 space-y-1">
                                        <li>Read, understood, and accepted these terms;</li>
                                        <li>Provided accurate and lawful information;</li>
                                        <li>Given consent to data processing in line with the NDPA 2023.</li>
                                    </ul>
                                </li>

                                <li>
                                    <h3 class="font-semibold pb-2">Severability</h3>
                                    <ol class="space-y-3">
                                        <li>
                                            If at any time any provision or part of this Agreement is or becomes invalid, illegal, or unenforceable under any applicable law, such provision shall be deemed modified to the minimum extent necessary to make it valid and enforceable. Where modification is not possible, the affected provision shall be severed from this Agreement without affecting the validity or enforceability of the remaining provisions.
                                        </li>
                                        <li>
                                            In all cases, the Parties expressly agree that the overall commercial intent and effect of this Agreement particularly the protection of <b>Sycamore's</b> rights and interests shall remain intact and enforceable to the fullest extent permitted by law.
                                        </li>
                                        <li>
                                            No delay, omission, or forbearance by <b>Sycamore Integrated Solutions Limited ("Sycamore")</b> in exercising any right, power, or remedy under this Agreement shall operate as a waiver of that right, power, or remedy. A waiver of any breach or default shall not be construed as a waiver of any subsequent breach or default.
                                        </li>
                                        <li>
                                            The Borrower acknowledges that any leniency, concession, or indulgence granted by Sycamore shall not prejudice or limit Sycamore's right to enforce strict compliance with the terms of this Agreement at any time thereafter.
                                        </li>
                                        <li>
                                            This offer is subject to a satisfactory credit report and further verification checks in event that your application is
        unsuccessful, your documents shall be returned to you.**
                                        </li>
                                    </ol>
                                </li>

                            </ol>
                        </div>

                        <div class="space-y-3 text-sm">
                            <h3 class="font-semibold">DISCLAIMER:</h3>
                            <p>
                                <i>As required by law, Sycamore Integrated Services is mandated to disclose the status
                                    of defaulting Sycamore
                                    Facility to relevant local or international Credit Bureaus, Credit Monitoring
                                    Agencies and Regulatory
                                    Bodies.</i>
                            </p>
                        </div>

                        <div class="flex flex-col md:flex-row md:justify-between md:items-end pb-6 text-base">
                            <div>
                                <p class="pb-1" :class="this.loan.contract_status != 'generated' ? 'pb-6' : ''">
                                    Thank you. <br /> For Sycamore Integrated Solutions Limited
                                </p>
                                <p v-if="this.loan.contract_status != 'generated'" class="pb-3">
                                    <span class="text-3xl font-Allura">
                                        {{ loan.Customer ? loan.Customer.name : '' }}
                                    </span>
                                    <br />
                                    <span class="text-sm">
                                        {{ loan.contract_decided_on ? moment(loan.contract_decided_on).format('DD, MMMM YYYY') : moment().format('DD, MMMM YYYY') }}
                                    </span>
                                    <br />
                                    <span class="text-xs">
                                        Contract {{ loan ? loan.contract_status : '' }}
                                    </span>
                                </p>
                                <p>
                                    Yours faithfully, <br> For Sycamore.
                                </p>
                            </div>

                            <div 
                                class="flex pt-6 pr-0 md:pr-6 space-x-3"
                                v-if="this.token && this.loan.contract_status == 'generated'"
                            >
                                <button type="button" @click="(decision = 'accept'), (isComponentModalActive = true)"
                                    :class="loadingStatus ? 'is-loading' : ''" :disabled="loadingStatus ? true : false"
                                    class="bg-green-500 rounded-sm py-2 px-6 text-white border border-green-600">
                                    Accept
                                </button>

                                <button type="button" @click="(decision = 'reject'), (isComponentModalActive = true)"
                                    :class="loadingStatus ? 'is-loading' : ''" :disabled="loadingStatus ? true : false"
                                    class="bg-red-500 rounded-sm py-2 px-6 text-white border border-red-600">
                                    Reject
                                </button>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
            <div v-if="activeTab == 1">
                <TokenInvalid />
            </div>
        </div>

        <b-modal v-model="isComponentModalActive" has-modal-card trap-focus aria-modal>
            <template #default="props">
                <transactionPassword :data="{
                    title: `${decision.charAt(0).toUpperCase() + decision.slice(1)
                        } contract`,
                    subtitle: 'Please provide your password to continue',
                    buttonLabel: decision,
                }" :loading="loadingStatus" @callback="fetchDecideContract" @close="props.close" />
            </template>
        </b-modal>
    </div>
</template>

<script>
import moment from "moment";
import Ripple from "@/components/Ripple";
import TokenInvalid from "@/components/TokenInvalid";
import transactionPassword from "@/components/transactionPassword";
import { fetchLoan, decideContract } from "@/api/loan";

export default {
    name: "Loan",

    components: {
        Ripple,
        transactionPassword,
        TokenInvalid
    },

    data() {
        return {
            loan: {},
            repayment_schedules: [],
            token: "",
            decision: "",
            password: "",
            currency: {},
            // to_naira_rate_with_buffer: null,
            // naira_object: null,
            loadingStatus: false,
            isComponentModalActive: false,
            activeTab: 0,

            errorStatus: [],
        }
    },

    computed: {
        total_interest() {
            let total = this.repayment_schedules.map(item => item.interestTobePaid).reduce((prev, curr) => prev + curr, 0);
            return total;
        },

        total_principal() {
            let total = this.repayment_schedules.map(item => item.principalTobePaid).reduce((prev, curr) => prev + curr, 0);
            return total;
        },

        maturity_date() {
            return this.loan.disburement_date ? moment(`${this.loan.disburement_date}`).add(this.loan.duration, `${this.loan.duration_type}`) : ""
        },

        first_schedule() {
            return this.repayment_schedules[0];
        },

        // totalDeductions() {
        //     return this.loan.DisbursementDeductions.reduce((total, deduction) => {
        //         return total + deduction.amount;
        //     }, 0);
        // }
    },

    methods: {
        moment: function (date) {
            return moment(date);
        },

        getLoan() {
            this.loadingStatus = true;
            const { offer_link } = this.$route.params

            fetchLoan(offer_link)

                .then((res) => {
                    let { loan, schedules } = res.data.data
                    // let { loan, schedules, to_naira_rate_with_buffer, naira_object } = res.data.data
                    this.loan = loan
                    this.repayment_schedules = schedules
                    this.currency = loan.Currency
                    // this.to_naira_rate_with_buffer = to_naira_rate_with_buffer
                    // this.naira_object = naira_object
                    this.activeTab = 0
                })

                .catch((error) => {
                    this.activeTab = 1
                    this.errorStatus = error.res;
                })

                .finally(() => {
                    this.loadingStatus = false
                })
        },

        fetchDecideContract(password) {
            this.loadingStatus = true
            const { token } = this.$route.query;
            const body = {
                loan_id: this.loan.loan_id,
                status: `${this.decision}ed`,
                password: password
            }

            decideContract(body, token)

                .then((res) => {
                    this.$toast.success(`Contract ${this.decision}ed Successfully`, {
                        timeout: 3000
                    });
                    this.isComponentModalActive = false
                    this.getLoan()
                })

                .catch((error) => {
                    this.$toast.error(error.response.data.message.errors[0].msg,
                        {
                            timeout: 5000
                        });
                })

                .finally(() => {
                    this.loadingStatus = false
                })
        }
    },

    mounted() {
        this.getLoan();
    },

    created() {
        this.token = this.$route.query.token;
    }
}
</script>

<style scoped>
.numbered {
    counter-reset: list-counter;
}

.numbered>li {
    counter-increment: list-counter;
    counter-reset: sub-counter;
    list-style: none;
}

.numbered>li::marker {
    content: counter(list-counter) ". ";
    font-weight: 600;
}

.numbered>li>ol {
    counter-reset: sub-counter;
    padding-left: 1.8rem;
}

.numbered>li>ol>li {
    counter-increment: sub-counter;
    counter-reset: sub-sub-counter;
    list-style: none;
}

.numbered>li>ol>li::marker {
    content: counter(list-counter) "." counter(sub-counter) " ";
}

.numbered>li>ol>li>ol {
    counter-reset: sub-sub-counter;
    padding-left: 2rem;
    padding-top: .5rem;
}

.numbered>li>ol>li>ol>li {
    counter-increment: sub-sub-counter;
    list-style: none;
}

.numbered>li>ol>li>ol>li::marker {
    content: counter(list-counter) "." counter(sub-counter) "." counter(sub-sub-counter) " ";
}
</style>